import React from "react";
import clsx from "clsx";
import coin from "../assets/images/placeholder/crypto-colour.png";

interface TradeHeaderProps {
  label?: string;
  assetSymbol?: string;
  amount: string;
  fiatAmount: string;
  assetName?: string;
  assetIcon?: string;
  isSmall?: boolean;
}

export const TradeHeader: React.FC<TradeHeaderProps> = ({
  label,
  assetSymbol,
  assetName,
  assetIcon,
  amount,
  fiatAmount,
  isSmall = false,
}) => {
  return (
    <div className="flex items-center gap-4">
      {label && assetSymbol && (
        <div
          className={clsx(
            "space-y-2 flex-shrink-0",
            isSmall ? "lg:w-44 w-32" : "w-56"
          )}
        >
          {label && (
            <label className="text-text-secondary text-sm">{label}</label>
          )}
          {assetSymbol && (
            <div
              className={clsx(
                "rounded-2xl border border-gray-200 bg-white",
                isSmall ? "p-3" : "p-4"
              )}
            >
              <div
                className={clsx(
                  "flex items-center",
                  isSmall ? "gap-2" : "gap-3"
                )}
              >
                <div
                  className={clsx(
                    "rounded-full flex items-center justify-center",
                    isSmall ? "w-8 h-8" : "w-10 h-10"
                  )}
                >
                  <img
                    src={assetIcon || coin}
                    alt={assetSymbol}
                    width={isSmall ? 20 : 24}
                    height={isSmall ? 20 : 24}
                    className="text-white"
                  />
                </div>
                <div className="text-left">
                  <div
                    className={clsx(
                      "font-semibold text-gray-800",
                      isSmall && "text-sm"
                    )}
                  >
                    {assetSymbol.toUpperCase()}
                  </div>
                  <div
                    className={clsx(
                      "text-gray-500",
                      isSmall ? "text-xs" : "text-sm"
                    )}
                  >
                    {assetName ?? assetSymbol}
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      )}

      <div className="space-y-2 flex-1">
        <label className="text-text-secondary text-sm">Amount</label>
        <div className="p-4 rounded-2xl bg-gray-50">
          <div className="flex items-center justify-between">
            <div className="text-lg font-semibold text-gray-800">{amount}</div>
            <div className="text-sm text-gray-500">≈ R {fiatAmount}</div>
          </div>
        </div>
      </div>
    </div>
  );
};
